import { Banner, Country } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { getCountryName } from '@/helpers/getCountryName';
import { useStorefront } from '@/components/Storefront/StorefrontProvider';

const CountryMismatchBanner = () => {
  const { t } = useTranslation('storefront');

  const { storefrontCheckoutForm } = useStorefront();

  const selectedShoppingCountry =
    storefrontCheckoutForm?.watch('shoppingCountry');

  const employeeAddressCountryCode = storefrontCheckoutForm?.getValues(
    'employee.address.country'
  ) as Country;

  return (
    <Banner
      id="country-mismatch-banner"
      isFlat
      isFullWidth
      intent="info"
      title={t('international.countryMismatchBanner.title')}
      message={
        selectedShoppingCountry && selectedShoppingCountry.value !== 'other'
          ? t('international.countryMismatchBanner.messageMatchedCountry', {
              countryName: getCountryName(selectedShoppingCountry.value),
            })
          : t('international.countryMismatchBanner.messageOtherCountry', {
              countryName: getCountryName(employeeAddressCountryCode),
            })
      }
    />
  );
};

export default CountryMismatchBanner;
